/**
 * Última aula aberta, por curso.
 *
 * Antes da plataforma multi-curso havia uma única chave global. Como um token
 * valia por um curso e trocar exigia relogar, a colisão era invisível: a aula
 * do outro curso simplesmente não era encontrada na lista e o registro era
 * ignorado. Com a troca de curso a um clique, isso passa a apontar o módulo
 * errado — daí o escopo por topicId.
 */

const LEGACY_KEY = 'neurodidatica_last_lesson';

export type StoredLastLesson = { id: string; moduleId: number | null };

function keyFor(topicId: number | undefined): string {
  return topicId == null ? LEGACY_KEY : `${LEGACY_KEY}:${topicId}`;
}

export function persistLastLesson(
  lesson: StoredLastLesson,
  topicId: number | undefined,
): void {
  try {
    localStorage.setItem(keyFor(topicId), JSON.stringify(lesson));
  } catch {
    // localStorage indisponível (modo privado / cota) — seguir sem persistir
  }
}

/**
 * Lê a última aula do curso. Cai na chave antiga quando a nova ainda não existe,
 * para não zerar o progresso de quem já usava o app antes do escopo por curso.
 */
export function readLastLesson(
  topicId: number | undefined,
): StoredLastLesson | null {
  const raw =
    localStorage.getItem(keyFor(topicId)) ??
    (topicId == null ? null : localStorage.getItem(LEGACY_KEY));

  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as StoredLastLesson;
    return typeof parsed?.id === 'string' ? parsed : null;
  } catch {
    return null;
  }
}
